import { render, staticRenderFns } from "./informativa-relativa-sito-web.vue?vue&type=template&id=30fb15d6"
import script from "./informativa-relativa-sito-web.vue?vue&type=script&lang=js"
export * from "./informativa-relativa-sito-web.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports